<!--Main Content-->
<div class="sod-Center">
	<h5>Do you want to add this sound for all schools in the district or only for {{ SchoolName }}?</h5>
</div>
<!--Buttons-->
<div class="sod-Buttons">
	<!--Add and keep-->
	<button class="btn sod-Graybtn" (click)="onDistrictAdd()">Add for District</button>
	<!--Add and delete-->
	<button class="btn sod-Graybtn" (click)="onSchoolAdd()">Add for {{ SchoolName }}</button>
	<!--Cancel/Close-->
	<button class="btn sod-Graybtn" (click)="onClose(-1)">Cancel</button>
</div>
